function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as tools from '../../utilities/_tools';
import config from '../../tokens/field.json';
export var Validation = /*#__PURE__*/function () {
  function Validation(prmForm) {
    _classCallCheck(this, Validation);
    this.formular = prmForm;
    this.submitEvent();
    this.submitWithButton();
    this.focusEventOnFields();
    this.blurEventOnFields();
    this.checkedEventForRadioAndCheckbox();
    this.changeEventCriterion();
  }

  /**
   * Support Safari, iOS Safari, and the Android browser—each of which do not prevent form submissions by default
   */
  return _createClass(Validation, [{
    key: "submitEvent",
    value: function submitEvent() {
      var _this = this;
      this.formular.addEventListener('submit', function (event) {
        if (!_this.formular.checkValidity()) {
          event.preventDefault();
        }
      });
    }

    /**
     * Init submit buttons click event in formular
     */
  }, {
    key: "submitWithButton",
    value: function submitWithButton() {
      var _this2 = this;
      var submitButton = this.formular.querySelector('button[type=submit], input[type=submit]');
      submitButton.addEventListener('click', function (event) {
        var fields = _this2.formular.querySelectorAll(".js-form-input, .js-input-upload, .".concat(config["class"], " select, .").concat(config["class"], " textarea, .js-form-radio, .js-form-checkbox, .js-form-ratingstar"));
        tools.forEach(fields, function (field) {
          if (!_isRadio(field) && !_isCheckbox(field) && !_isRatingstar(field)) {
            if (_isTrimable(field)) {
              field.value = field.value.trim();
            }
            if (field.checkValidity()) {
              if (field.matches('.js-input-criterion')) {
                if (field.parentElement.querySelector('.js-criteria-list').querySelectorAll('.is-invalid').length > 0) {
                  _turnInvalid(field, event.type);
                  event.preventDefault();
                  return;
                }
              }
              if (!_isEmpty(field)) {
                if (!_isDefaultValue(field)) {
                  _turnValid(field);
                } else {
                  _turnInvalid(field, event.type);
                  event.preventDefault();
                }
              }
            } else {
              _turnInvalid(field, event.type);
              event.preventDefault();
            }
          } else {
            var listContainer = tools.getClosest(field, '.js-form-field-list') || tools.getClosest(field, '.mc-checkbox');
            var listInputs = listContainer.querySelectorAll('.js-form-radio, .js-form-checkbox, .js-form-ratingstar');
            var minRequired = listContainer.dataset.minRequired ? listContainer.dataset.minRequired : field.hasAttribute('required') ? 1 : 0;
            var listInputsChecked = listContainer.querySelectorAll('.js-form-radio:checked, .js-form-checkbox:checked, .js-form-ratingstar:checked');
            var arrayListInputs = Array.from(listInputs);
            if (!arrayListInputs.find(function (el) {
              return el === document.activeElement;
            })) {
              if (listInputsChecked.length < minRequired || field.hasAttribute('required') && _isRatingstar(field) && field.value === '0') {
                tools.forEach(listInputs, function (el) {
                  el.classList.remove('is-valid');
                  el.classList.add('is-invalid');
                  event.preventDefault();
                });
                _manageErrorMsg(arrayListInputs.find(function (el) {
                  return !el.matches(':checked');
                }));
              }
            }
          }
        });
      });
    }

    /**
     * Init event to triggered focus event on fields from formular
     */
  }, {
    key: "focusEventOnFields",
    value: function focusEventOnFields() {
      var fields = this.formular.querySelectorAll(".js-form-input, .".concat(config["class"], " select, .").concat(config["class"], " textarea"));
      tools.forEach(fields, function (field) {
        field.addEventListener('focus', function () {
          _resetValidity(field);
        });
      });
    }

    /**
     * Init event to triggered blur event on fields from formular
     */
  }, {
    key: "blurEventOnFields",
    value: function blurEventOnFields() {
      var fields = this.formular.querySelectorAll(".js-form-input, .js-input-upload, .".concat(config["class"], " select, .").concat(config["class"], " textarea"));
      tools.forEach(fields, function (field) {
        field.addEventListener('blur', function () {
          _resetValidity(field);
          if (_isTrimable(field)) {
            field.value = field.value.trim();
          }
          if (field.checkValidity()) {
            if (field.matches('.js-input-criterion')) {
              if (field.nextElementSibling.querySelectorAll('.is-invalid').length > 0) {
                _turnInvalid(field);
                return;
              }
            }
            if (!_isEmpty(field)) {
              if (!_isDefaultValue(field)) {
                _turnValid(field);
              } else {
                _turnInvalid(field);
              }
            }
          } else {
            _turnInvalid(field);
          }
        });
      });
    }

    /**
     * Init event to triggered checked event on radio buttons and checkbox from formular
     */
  }, {
    key: "checkedEventForRadioAndCheckbox",
    value: function checkedEventForRadioAndCheckbox() {
      var fields = this.formular.querySelectorAll('.js-form-radio, .js-form-checkbox, .js-form-ratingstar');
      tools.forEach(fields, function (field) {
        var listContainer = tools.getClosest(field, '.js-form-field-list') || tools.getClosest(field, '.mc-checkbox');
        var listInputs = listContainer.querySelectorAll('.js-form-radio, .js-form-checkbox, .js-form-ratingstar');
        var minRequired = listContainer.dataset.minRequired ? listContainer.dataset.minRequired : field.hasAttribute('required') ? 1 : 0;
        var listInputsChecked;
        field.addEventListener('change', function () {
          listInputsChecked = listContainer.querySelectorAll('.js-form-radio:checked, .js-form-checkbox:checked, .js-form-ratingstar:checked');
          tools.forEach(listInputs, function (el) {
            el.required = listInputsChecked.length < minRequired;
            _resetValidity(el);
          });
        });
        field.addEventListener('blur', function () {
          listInputsChecked = listContainer.querySelectorAll('.js-form-radio:checked, .js-form-checkbox:checked, .js-form-ratingstar:checked');
          setTimeout(function () {
            var arrayListInputs = Array.from(listInputs);
            if (!arrayListInputs.find(function (el) {
              return el === document.activeElement;
            })) {
              if (listInputsChecked.length < minRequired || field.hasAttribute('required') && _isRatingstar(field) && field.value === '0') {
                tools.forEach(listInputs, function (el) {
                  el.classList.remove('is-valid');
                  el.classList.add('is-invalid');
                });
                _manageErrorMsg(arrayListInputs.find(function (el) {
                  return !el.matches(':checked');
                }));
              }
            }
          }, 1);
        });
      });
    }

    /**
     * Init event on fields that's have criterion from formular
     */
  }, {
    key: "changeEventCriterion",
    value: function changeEventCriterion() {
      var inputsWithCriterion = this.formular.querySelectorAll('.js-input-criterion');
      tools.forEach(inputsWithCriterion, function (input) {
        var criterionList = _getCriterion(input);
        tools.forEach(['keyup', 'mouseup', 'change'], function (eventType) {
          input.addEventListener(eventType, function () {
            _validCriterion(input, criterionList);
          });
        });
        input.dispatchEvent(new CustomEvent('change', {
          'target': input
        }));
      });
    }
  }]);
}();

/**
 * Reset validty of field
 * @param {Node} prmField
 */
function _resetValidity(prmField) {
  prmField.classList.remove('is-valid', 'is-invalid');
  _manageErrorMsg(prmField);
}

/**
 * Valid field and add good CSS classes
 * @param {Node} prmField
 */
function _turnValid(prmField) {
  prmField.classList.remove('is-invalid');
  prmField.classList.add('is-valid');
  _manageErrorMsg(prmField);
}

/**
 * Invalid field and add good CSS classes
 * @param {Node} prmField
 */
function _turnInvalid(prmField, eventType) {
  prmField.classList.remove('is-valid');
  prmField.classList.add('is-invalid');
  _manageErrorMsg(prmField);
  if (eventType === 'click') {
    document.querySelector('.is-invalid').focus();
  }
}

/**
 * Show/Hide errors message from field
 * @param {Node} prmField
 */
function _manageErrorMsg(prmField) {
  var fieldContainer = tools.getClosest(prmField, ".".concat(config["class"]));
  var errorMsg = fieldContainer.querySelector('.js-form-error');
  if (errorMsg) {
    prmField.removeAttribute('aria-describedby');
    errorMsg.remove();
  }
  if (prmField.matches('.js-input-criterion.is-invalid')) {
    if (_isEmpty(prmField)) {
      prmField.insertAdjacentHTML('afterend', _makeError(prmField, 'missing'));
    } else {
      prmField.insertAdjacentHTML('afterend', _makeError(prmField, 'mismatch'));
    }
    return;
  }
  if (prmField.matches('.is-invalid:not(.km-field__criteria-list__item)')) {
    if (_isEmpty(prmField) || _isRadio(prmField) || _isCheckbox(prmField) || _isRatingstar(prmField) || _isSelect(prmField)) {
      fieldContainer.insertAdjacentHTML('beforeend', _makeError(prmField, 'missing'));
    } else {
      fieldContainer.insertAdjacentHTML('beforeend', _makeError(prmField, 'mismatch'));
    }
  }
}

/**
 * Append error message depending prmErrorType value
 * @param {Node} prmField
 * @param {String} prmErrorType
 */
function _makeError(prmField, prmErrorType) {
  var msg;
  var cssClass;
  var tplPrefix = '';
  var tplSuffix = '';
  if (_isRadio(prmField) || _isCheckbox(prmField) || _isRatingstar(prmField)) {
    var checkableList = tools.getClosest(prmField, '.js-form-field-list');
    msg = checkableList.dataset["".concat(prmErrorType)] ? checkableList.dataset["".concat(prmErrorType)] : '';
    cssClass = checkableList.dataset['errorWrapper'] || '';
    cssClass += ' js-form-error';
    if (checkableList.dataset['errorWrapper']) {
      tplPrefix = '<div class="col-container-inner js-form-error">';
      tplSuffix = '</div>';
    }
  } else {
    msg = prmField.dataset["".concat(prmErrorType)] ? prmField.dataset["".concat(prmErrorType)] : '';
    cssClass = "".concat(prmField.dataset['errorWrapper'] ? prmField.dataset['errorWrapper'] : '', " js-form-error");
  }
  // role alert ? only on blur ?
  prmField.setAttribute('aria-describedby', "".concat(prmField.id, "-error"));
  var tpl = "".concat(tplPrefix, "<span class=\"").concat(config["class"]).concat(config.error, " ").concat(cssClass, "\" id=\"{{=it.id}}-error\">{{=it.msg}}</span>").concat(tplSuffix);
  return tools.template(tpl, {
    'msg': msg,
    'id': prmField.id
  });
}

/**
 * Get all valids criterion from a field
 * @param {Node} prmField
 */
function _getCriterion(prmField) {
  var criterion = tools.getClosest(prmField, ".".concat(config["class"])).querySelectorAll('.km-field__criteria-list li');
  var criterionList = [];
  tools.forEach(criterion, function (criteria) {
    var pattern = {
      'pattern': new RegExp(criteria.getAttribute('data-pattern')),
      'element': criteria
    };
    criterionList.push(pattern);
  });
  return criterionList;
}

/**
 * Valid a field if all criterions are validated
 * @param {Node} prmField
 * @param {Array} prmCriterionList
 */
function _validCriterion(prmField, prmCriterionList) {
  tools.forEach(prmCriterionList, function (criteria) {
    var pattern = criteria.pattern;
    if (pattern.test(prmField.value)) {
      _turnValid(criteria.element);
    } else {
      _turnInvalid(criteria.element);
    }
  });
}

/**
 * Check if selected value is not default value
 * @param {Node} prmField
 */
function _isDefaultValue(prmField) {
  var options = prmField.querySelectorAll('option');
  for (var i = 0; i < options.length; i++) {
    if (options[i].dataset.order === prmField.value) {
      return options[i].dataset.order === prmField.value;
    }
  }
  return false;
}

/**
 * Test if field value is equal to ''
 * @param {Node} prmField
 */
function _isEmpty(prmField) {
  return prmField.value === '';
}

/**
 * Test if field is a radio button
 * @param {Node} prmField
 */
function _isRadio(prmField) {
  return prmField.type === 'radio';
}

/**
 * Test if field is a checkbox
 * @param {Node} prmField
 */
function _isCheckbox(prmField) {
  return prmField.type === 'checkbox';
}

/**
 * Test if field is a rating stars input
 * @param {Node} prmField
 */
function _isRatingstar(prmField) {
  return prmField.type === 'radio' && prmField.classList.contains('js-form-ratingstar');
}

/**
 * Test if field is a select
 * @param {Node} prmField
 * @returns
 */
function _isSelect(prmField) {
  return prmField.tagName === 'SELECT';
}

/**
 * Test if fiels is a textual one
 * @param {Node} prmField
 */
function _isTrimable(prmField) {
  return prmField.type === 'text';
}